import React from 'react';
import { Box , Image } from '@chakra-ui/react'
import DashboardHeader from './DashboardHeader';

export default function Topbar() {
	const data = { username: 'Uzo', currentPage: ''  };

	return (
        <Box className="outer-dashboard-header-wrap">
			<div className="outer-dashboard-header">
				<Image
					boxSize='30px'
					objectFit='cover'
					src='https://placehold.co/600x400?text=Insert+Company+Logo+Here'
					alt='Company Logo here'
				/>
			<DashboardHeader {...data} isOuterDashboard={true} />
		</div>
	    </Box>
    )
};